import React, { Component } from 'react';

export default class saleLimitDate extends Component {
  constructor(props) {
    super(props);
  }

  validateNameClient = (client) => {
    let firstName = '';
    let lastName = '';

    if (client && client[0] && client[0].firstName) {
      firstName = client[0].firstName;
    }

    if (client && client[0] && client[0].lastName) {
      lastName = client[0].lastName;
    }

    return firstName + ' ' + lastName;
  };

  render() {
    const { clientInfo } = this.props.data;
    return <div>{this.validateNameClient(clientInfo)}</div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/CellRenderer/nameClientCellRenderer.jsx